module.exports = {
	"name": "BrewPlanner",
	"version": "2.51.76",
	"description": "Application for scheduled brew production.",
	"repository": {
		"type": "git",
		"url": "https://jero786@bitbucket.org:jero786/brewplanner.git"
	},
	"engines": {
		"node": ">=0.10.0"
	},
	"scripts": {
		"dev": "grunt serve",
		"start": "node server.js",
		"cypress:open": "npx cypress open",
		"cypress:run:po": "npx cypress run --spec 'cypress/e2e/purchaseItems/purchaseItems.spec.js'"
	},
	"main": "src/components/main.js",
	"private": true,
	"src": "src",
	"test": "test",
	"dist": "../brewplanner-schedule/src/main/resources/static",
	"mainInput": "main",
	"mainOutput": "main",
	"dependencies": {
		"bounding-client-rect": "^1.0.5",
		"currency-formatter": "^1.2.1",
		"es6-promise": "^4.1.0",
		"eventlistener": "0.0.1",
		"events": "1.1.0",
		"flux": "2.1.1",
		"immutable": "^3.8.1",
		"jquery": "3.1.0",
		"json-loader": "^0.5.4",
		"keymirror": "0.1.1",
		"locale-helpers": "^1.0.142",
		"lodash": "4.5.1",
		"material-ui": "0.11.1",
		"minimatch": "^3.0.4",
		"moment": "2.11.2",
		"moment-timezone": "^0.5.13",
		"node-sass": "^9.0.0",
		"normalize.css": "3.0.3",
		"numeral": "^2.0.6",
		"object-assign": "2.1.1",
		"react": "0.13",
		"react-ga": "1.2.0",
		"react-grid-layout": "0.8.5",
		"react-notification-system": "0.1.17",
		"react-router": "0.13.2",
		"react-tap-event-plugin": "0.2.2",
		"rest": "1.3.1",
		"sass-loader": "3.2.0",
		"spectrum-colorpicker": "1.8.0",
		"uploadcare-widget": "^2.10.3"
	},
	"devDependencies": {
		"babel-core": "6.9.0",
		"babel-loader": "6.2.4",
		"babel-plugin-transform-object-assign": "^6.5.0",
		"babel-polyfill": "^6.9.0",
		"babel-preset-es2015": "^6.9.0",
		"babel-preset-es2015-loose": "^7.0.0",
		"babel-preset-react": "6.5.0",
		"babel-preset-stage-2": "6.5.0",
		"compression-webpack-plugin": "^0.2.0",
		"css-loader": "~0.9.0",
		"enzyme": "^2.9.1",
		"eslint": "^1.3.1",
		"eslint-loader": "^1.0.0",
		"eslint-plugin-react": "^3.3.0",
		"expect": "^1.18.0",
		"expect-enzyme": "^1.0.0",
		"expect-immutable": "0.0.3",
		"expect-jsx": "^3.0.0",
		"file-loader": "^0.8.4",
		"grunt": "~0.4.5",
		"grunt-contrib-clean": "~0.6.0",
		"grunt-contrib-connect": "~0.8.0",
		"grunt-contrib-copy": "~0.5.0",
		"grunt-contrib-watch": "1.0.0",
		"grunt-karma": "~0.8.3",
		"grunt-open": "~0.2.3",
		"grunt-webpack": "~1.0.8",
		"html-loader": "^0.3.0",
		"imagemin": "^3.2.0",
		"jasmine-core": "2.5.2",
		"jshint": "^2.9.1",
		"jshint-loader": "~0.8.0",
		"json-loader": "^0.5.4",
		"jsxhint-loader": "~0.2.0",
		"karma": "^1.7.0",
		"karma-chrome-launcher": "^2.2.0",
		"karma-coverage": "^0.4.2",
		"karma-firefox-launcher": "~0.1.3",
		"karma-jasmine": "^1.1.0",
		"karma-puppeteer-launcher": "^1.0.4",
		"karma-script-launcher": "~0.1.0",
		"karma-sourcemap-loader": "^0.3.7",
		"karma-webpack": "^2.0.3",
		"load-grunt-tasks": "~0.6.0",
		"puppeteer": "^22.10.0",
		"react-hot-loader": "^1.0.7",
		"style-loader": "~0.8.0",
		"url-loader": "~0.5.5",
		"webpack": "^1.13.1",
		"webpack-dev-server": "^1.14.1"
	}
};


/*****************
 ** WEBPACK FOOTER
 ** ./package.json
 ** module id = 312
 ** module chunks = 0
 **/